import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { IUserInfo } from "../../../../models/User";
import { generalConst } from "../../../../module/globalInterface";

export interface IDelegationManagementStepThreeProps {
  userInfo: IUserInfo;
  selectedRole: { role: any; target: any };
  users: any[];
  usersLoader: any;
  selectedUsers: any[];
  callState: IResponseState;
  consultantDelegationEnabled: boolean;
  delegationUserRequest: () => {};
  delegationUserBAORequest: (role: string) => {};
  modifySelectedUsersDelegation: (selectedUsers: object[]) => {};
  createDelegationRequest: (delegationOBJ: {}) => {};
  changeLocation: (url: string) => {};
}

export const ROLE_TYPE: generalConst = {
  RESPONSABILE_PERSON: "Responsabile Person",
  RESPONSABILE_OU: "Responsabile OU",
  BAO: "BAO",
};

export const DELEGATION_MANAGEMENT_STEP_3_FORM_FILTER =
  "DelegationManagementStep3FormFilter";

export const mockUsers: any[] = [
  {
    id: 1,
    name: "Marco",
    surname: "Rossi",
    code: "1",
    type: "Interno",
    appointee: "Nome Cognome",
    company: "Assist Digital",
    organizational_unit: "Ufficio Rischi",
  },
  {
    id: 2,
    name: "Fabio",
    surname: "Bianchi",
    code: "2",
    type: "Interno",
    appointee: "Nome Cognome",
    company: "Assist Digital",
    organizational_unit: "Ufficio Rischi",
  },
  {
    id: 3,
    name: "Matteo",
    surname: "Neri",
    code: "3",
    type: "Interno ",
    appointee: "Nome Cognome",
    company: "Assist Digital",
    organizational_unit: "Ufficio Rischi",
  },
];
